const iconsMap = {
  yellow_circle: "bh_vamp_question_mark",
  hourglass: "bh_vamp_clock",
  yellow_triangle: "bh_vamp_error",
  red_triangle: "bh_vamp_error",
  green_checkmark: "bh_vamp_check",
  lock: "bh_vamp_lock"
}

const statusVariantMap = {
  pending: "pending",
  compliant: "success",
  warning: "warning",
  under_monitoring: "error",
  no_status: "neutral"
}

export const getMonitoringMonthIcon = (iconName, status) => {
  let icon = iconsMap[iconName] || "bh_vamp_question_mark"
  let variant = statusVariantMap[status] || "neutral"

  if (iconName === "yellow_circle") variant = "in-progress"

  if (!icon) icon = "bh_vamp_question_mark"
  if (!variant) variant = "neutral"

  return { icon, variant }
}
